import {Helmet} from "react-helmet-async";
import {
  Box as MuiBox,
  Divider as MuiDivider,
  Grid, Theme, Typography,
  Typography as MuiTypography,
  useMediaQuery
} from "@material-ui/core";
import PropertySearch from "../../standards/components/PropertySearch";
import PropertyFilters from "../../standards/components/PropertyFilters";
import RenderProperties from "../../standards/components/RenderProperties";
import GridSkeleton from "../../../../components/GridSkeleton";
import {Pagination} from "@material-ui/lab";
import React, {useContext, useEffect, useState} from "react";
import styled from "styled-components/macro";
import {spacing} from "@material-ui/system";
import {AppDispatchType, useSelector} from "../../../../redux/store";
import {IUser} from "../../../../models/User";
import {getUserProfile} from "../../../../selectors";
import {CompaniesContext} from "../../../../components/contexts/CompaniesContext";
import CreateNewCompany from "../components/CreateNewCompany";
import { urls, useRouting } from "../../../../routes";
import {clearCompany, fetchPagedCompanies} from "../../../../redux/actions/companyActions";
import {useDispatch} from "react-redux";
import RenderCompanies from "../components/RenderCompanies";
import CompanySearch from "../components/CompanySearch";

const Box = styled(MuiBox)(spacing);
const Divider = styled(MuiDivider)(spacing);

const SearchWrapper = styled(Grid)`
  margin-bottom: 24px; 
`

const CompaniesPage = () => {
  const dispatch = useDispatch()
  const { routeTo } = useRouting()
  const {
    searchState,
    pageState
  } = useContext(CompaniesContext);
  const [page, setPage] = pageState;
  const [search, setSearch] = searchState;
  const user = useSelector((state) => state.authReducer.user!)
  const userProfile = useSelector<IUser | undefined>(getUserProfile);
  const count = useSelector((state) => state.companyReducer.count)
  const [loading, setLoading] = useState(false)
  const companies = useSelector((state) => state.companyReducer.pagedCompanies)
  const sm = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  useEffect(() => {
    if (userProfile?.is_staff) {
      setLoading(true)
      dispatch( async (dispatch: AppDispatchType) => {
        await fetchPagedCompanies(user!.token, page, search)(dispatch)
        scrollToTop();
        setLoading(false)
      })
    }
  }, [userProfile]);

  const scrollToTop = () => {
    const header = document.getElementById("app-header");
    header!.scrollIntoView({
      behavior: "smooth"
    });
  }

  const handleChangePage = (_: any, value: number) => {
    setLoading(true)
    dispatch(async (dispatch: AppDispatchType) => {
      await fetchPagedCompanies(user!.token, value, search)(dispatch)
      setPage(value);
      scrollToTop();
      setLoading(false)
    })
  };

  const handleClick = () => {
    routeTo(urls.createNewCompany)
  }

  const handleEditCompany = (id: string) => {
    dispatch(clearCompany())
    routeTo(urls.editCompany, { id })
  }

  return (
    <Box p={12} className={`disable-scrolls`} overflow="scroll">
      <Helmet title={'Companies'} />
      <MuiTypography variant="h3" gutterBottom display="inline" id="app-header">
        Companies List
      </MuiTypography>
      <Divider my={6} />
      <SearchWrapper container>
        <Grid item xs={12} md={3}>
          <CompanySearch
            search={search}
            onSetPage={setPage}
            onSetSearch={setSearch}
            onSetLoading={setLoading}
          />
        </Grid>
      </SearchWrapper>
      <Grid container spacing={6}>
        {page === 1 && <Grid item md={4} sm={6} xs={12} lg={3} style={{ display: "flex" }}>
          <CreateNewCompany handleClick={handleClick} />
        </Grid>}
        {!loading && companies && companies.length > 0 ? (
          <RenderCompanies
            companies={companies}
            onClick={() => {}}
            onEdit={handleEditCompany}
          />
        ) : null}
        {!loading && companies?.length === 0 ? (
          <Grid item md={8} sm={6} xs={12} lg={9} style={{height: 281}}/>
        ) : null}
        {loading ? (
          <GridSkeleton
            count={7}
            height={259}
            container={false}
          />
        ) : null}
      </Grid>
      <Box mt={6}>
        {(companies && count && (count + 1) > 8) ? (
          <Pagination
            size={sm ? "small" : "medium"}
            count={Math.ceil(count / 8)}
            page={page}
            onChange={handleChangePage}
            showFirstButton
            showLastButton
          />
        ) : null}
      </Box>
    </Box>
  )
}

export default CompaniesPage